import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { QuizBreadcrumbContainer } from './QuizBreadcrumbContainer';

interface RouterParams {
  courseID: string;
  lessonID: string;
  quizID: string;
}

type Props = {
  dismissTakeABreakQuestion: () => void
  finishPartialQuiz: () => void
  params: RouterParams
  currentQuestion: number
  totQ: number
}

const QuizTakeABreakQuestion: React.FunctionComponent<Props> = ({
  dismissTakeABreakQuestion,
  finishPartialQuiz,
  params,
  currentQuestion,
  totQ,
}) => {
  const questionsLeft = totQ - currentQuestion;

  return (
    <div className="content container quiz-complete">
      <div className="main-content content-without-sidebar ">
        <Row className="sub-header">
          <QuizBreadcrumbContainer params={params} />
        </Row>
        <Row className="question text-center">
          <h2 style={{ fontSize: "26px", marginTop: "50px", marginBottom: "20px" }}>
            Would you like to take a break,<br/>or would you like to keep going<br/>to finish the exercise?
          </h2>
        </Row>
        <Row className="question">
          <Col md={12} sm={12} xs={12} className="text-center">
            <p style={{ marginBottom: "20px" }}>
              {questionsLeft} questions left
            </p>
            <Button bsStyle="primary" style={{ marginLeft: 10 }} onClick={finishPartialQuiz}>
              Take a break
            </Button>
            <Button bsStyle="primary" style={{ marginLeft: 10 }} onClick={dismissTakeABreakQuestion}>
              Keep going and finish the exercise
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default QuizTakeABreakQuestion;
